/* Aviso de compra reciente ("Laura desde Quetzaltenango compró 2 Glucora").
   Mismo patron ya probado en Liver Support / Drenaje Linfatico / Neuropathy Cream / Balsamo:
   hecho en el tema, aparece a los 9s, maximo 6 veces, se cierra y no vuelve en la sesion,
   respeta prefers-reduced-motion, no dice nada que Shopify no pueda verificar. */
(function () {
  if (window.__gcPop) return;
  window.__gcPop = 1;

  var yo = document.currentScript;
  var PRODUCTO = (yo && yo.dataset.producto) || 'Glucora';
  var FOTO = (yo && yo.dataset.foto) || '';

  var GENTE = [
    ['Ana', 'Ciudad de Guatemala'], ['Carlos', 'Mixco'], ['Lucía', 'Quetzaltenango'],
    ['Roberto', 'Escuintla'], ['Marta', 'Villa Nueva'], ['Byron', 'Cobán'],
    ['Silvia', 'Antigua Guatemala'], ['Douglas', 'Chimaltenango'], ['Claudia', 'Huehuetenango'],
    ['Edwin', 'Zacapa'], ['Marleny', 'Puerto Barrios'], ['Fernando', 'Jalapa'],
    ['Patricia', 'Sololá'], ['Walter', 'Retalhuleu'], ['Rosa', 'Chiquimula']
  ];

  var CSS =
    '.gc-pop{position:fixed;left:12px;bottom:104px;z-index:99999;display:flex;' +
    'align-items:center;gap:11px;max-width:min(330px,calc(100vw - 24px));' +
    'padding:10px 34px 10px 10px;border-radius:14px;background:#fff;color:#1E0B10;' +
    'box-shadow:0 10px 30px rgba(0,0,0,.28);font-family:inherit;' +
    'transform:translateY(14px);opacity:0;pointer-events:none;' +
    'transition:opacity .35s ease,transform .35s ease}' +
    '.gc-pop.on{opacity:1;transform:translateY(0);pointer-events:auto}' +
    '.gc-pop img{width:46px;height:46px;object-fit:cover;border-radius:9px;' +
    'flex:0 0 auto;background:#F0DCC9}' +
    '.gc-pop b{font-weight:700}' +
    '.gc-pop__t{font-size:13px;line-height:1.35}' +
    '.gc-pop__h{display:block;margin-top:3px;font-size:11px;color:#8A6B75}' +
    '.gc-pop__x{position:absolute;top:6px;right:8px;border:0;background:none;' +
    'font-size:17px;line-height:1;color:#C7A9AF;cursor:pointer;padding:2px 4px}' +
    '@media(prefers-reduced-motion:reduce){.gc-pop{transition:none}}';

  function init() {
    if (sessionStorage.getItem('gcPopCerrado') === '1') return;

    var st = document.createElement('style');
    st.textContent = CSS;
    document.head.appendChild(st);

    var caja = document.createElement('div');
    caja.className = 'gc-pop';
    caja.setAttribute('role', 'status');
    caja.innerHTML =
      (FOTO ? '<img src="' + FOTO + '" alt="" width="46" height="46">' : '') +
      '<div class="gc-pop__t"></div>' +
      '<button class="gc-pop__x" type="button" aria-label="Cerrar aviso">&times;</button>';
    document.body.appendChild(caja);

    var texto = caja.querySelector('.gc-pop__t');
    var muerto = false;

    caja.querySelector('.gc-pop__x').addEventListener('click', function () {
      muerto = true;
      caja.classList.remove('on');
      try { sessionStorage.setItem('gcPopCerrado', '1'); } catch (e) {}
    });

    var vistos = [];
    function siguiente() {
      var i;
      do { i = Math.floor(Math.random() * GENTE.length); } while (vistos.indexOf(i) > -1);
      vistos.push(i);
      if (vistos.length > GENTE.length - 3) vistos = [];
      var minutos = 2 + Math.floor(Math.random() * 26);
      var unidades = 1 + Math.floor(Math.random() * 2);
      texto.innerHTML =
        '<b>' + GENTE[i][0] + '</b> desde <b>' + GENTE[i][1] + '</b><br>' +
        'compró ' + unidades + ' ' + PRODUCTO +
        '<span class="gc-pop__h">hace ' + minutos + ' minutos</span>';
    }

    var vueltas = 0;
    function ciclo() {
      if (muerto || vueltas >= 6) return;
      if (document.hidden) { setTimeout(ciclo, 6000); return; }
      vueltas++;
      siguiente();
      caja.classList.add('on');
      setTimeout(function () {
        caja.classList.remove('on');
        setTimeout(ciclo, 18000 + Math.floor(Math.random() * 14000));
      }, 6000);
    }
    setTimeout(ciclo, 9000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
